(function () {
  'use strict';

  /* @ngdoc object
   * @name paxMessageConfig
   * @description
   *
   */
  angular
    .module('paxMessageConfig', [
      'ui.router'
    ]);
}());